





import Vue from "vue";
import { Component } from "vue-property-decorator";
export default class APP extends Vue {}
